import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TextField,
  Chip,
  Stack,
  Paper,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {
  getDeductiblesRules,
  saveDeductiblesRules,
  loadDeductiblesRules,
} from "../components/mobility/data/deductiblesRules";
import toast from "../lib/toast";
import { useEffect } from "react";

const ZONES = ["1", "2", "3", "4", "3bis"];

export default function AdminConditions() {
  const [editableRules, setEditableRules] = useState(getDeductiblesRules());

  useEffect(() => {
    setEditableRules(loadDeductiblesRules());
  }, []);

  const handleRuleChange = (ruleKey, zone, field, value) => {
    const newRules = { ...editableRules };
    if (!newRules[ruleKey].rules[zone]) newRules[ruleKey].rules[zone] = {};
    newRules[ruleKey].rules[zone][field] = value;
    setEditableRules(newRules);
  };

  const handleLimitChange = (ruleKey, value) => {
    const newRules = { ...editableRules };
    newRules[ruleKey].limit = value;
    setEditableRules(newRules);
  };

  const saveConditions = () => {
    saveDeductiblesRules(editableRules);
    toast.success(
      "Condizioni salvate: Le modifiche sono state salvate con successo",
    );
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Gestione Scoperti e Franchigie
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Configura scoperti, franchigie e limiti per ogni garanzia
          </Typography>
        </Box>
      </Box>

      {/* Action Bar */}
      <Card elevation={2} sx={{ mb: 3 }}>
        <CardContent>
          <Button
            variant="contained"
            color="success"
            startIcon={<SaveIcon />}
            onClick={saveConditions}
          >
            Salva Modifiche
          </Button>
        </CardContent>
      </Card>

      {/* Rules */}
      <Stack spacing={3}>
        {Object.entries(editableRules).map(([ruleKey, rule]) => (
          <Card key={ruleKey} elevation={3}>
            <Box
              sx={{
                p: 2.5,
                borderBottom: 1,
                borderColor: "divider",
                bgcolor: "action.hover",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography sx={{ fontSize: "1.8rem" }}>
                  {rule.emoji}
                </Typography>
                <Box>
                  <Typography variant="subtitle1" fontWeight={700}>
                    {rule.name}
                  </Typography>
                  <Stack direction="row" spacing={0.75} sx={{ mt: 0.5 }}>
                    {rule.appliesTo.map((pkg) => (
                      <Chip
                        key={pkg}
                        label={pkg}
                        size="small"
                        variant="outlined"
                      />
                    ))}
                  </Stack>
                </Box>
              </Box>
              {rule.limit && (
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                    sx={{ mb: 0.5 }}
                  >
                    Limite
                  </Typography>
                  <TextField
                    value={rule.limit}
                    onChange={(e) => handleLimitChange(ruleKey, e.target.value)}
                    size="small"
                    placeholder="Es. €6.000 per sinistro"
                    sx={{ width: 220 }}
                  />
                </Box>
              )}
            </Box>
            <CardContent>
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Zona</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Scoperto</strong>
                      </TableCell>
                      <TableCell align="center">
                        <strong>Franchigia</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ZONES.map((zone) => {
                      const zoneRule = rule.rules[zone] || {};
                      return (
                        <TableRow key={zone} hover>
                          <TableCell>
                            <Chip
                              label={`Zona ${zone}`}
                              size="small"
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell align="center" sx={{ p: 1 }}>
                            <TextField
                              value={zoneRule.scoperto || ""}
                              onChange={(e) =>
                                handleRuleChange(
                                  ruleKey,
                                  zone,
                                  "scoperto",
                                  e.target.value,
                                )
                              }
                              placeholder="Es. 10%"
                              size="small"
                              inputProps={{
                                style: { textAlign: "center", width: 100 },
                              }}
                            />
                          </TableCell>
                          <TableCell align="center" sx={{ p: 1 }}>
                            <TextField
                              value={zoneRule.franchigia || ""}
                              onChange={(e) =>
                                handleRuleChange(
                                  ruleKey,
                                  zone,
                                  "franchigia",
                                  e.target.value,
                                )
                              }
                              placeholder="Es. €250"
                              size="small"
                              inputProps={{
                                style: { textAlign: "center", width: 100 },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Container>
  );
}
